import { Box, Icon, Spinner, Stack, Text, Tooltip } from "@bookingcom/bui-react";
import { QuestionMarkCircleIcon } from "@bookingcom/bui-assets-react/streamline";
import { useI18n } from "@bookingcom/lingojs-react";
import { getMetricBoxConfig } from "../../constants";
import styles from "./CampaignImpact.module.css";

export const CampaignImpactSuspense = () => {
  const i18n = useI18n();

  return (
    <Stack direction="row" gap={0} alignItems="start" divided>
      {getMetricBoxConfig(i18n).map((config) => (
        <Stack direction="column" key={config.metricName} gap={2} grow className={styles.card}>
          <Stack direction="row" alignItems="baseline" gap={2}>
            <Text variant="body_1">{config.label}</Text>
            <Tooltip text={config.tooltip} position="top-start">
              {(attributes) => (
                <Icon svg={QuestionMarkCircleIcon} size="small" color="action" attributes={attributes} />
              )}
            </Tooltip>
          </Stack>

          <Box mixin={{ padding: 0 }} className={styles.spinnerContainer}>
            <Spinner size="medium" />
          </Box>
        </Stack>
      ))}
    </Stack>
  );
};
